import { Heart, Github, Twitter, MessageCircle } from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-cyber-dark border-t border-cyber-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gradient-to-br from-cyber-neon to-cyber-pink rounded-lg flex items-center justify-center">
                <span className="text-white font-bold">P</span>
              </div>
              <span className="text-lg font-bold text-white">Phygital</span>
            </div>
            <p className="text-sm text-gray-400">
              中小IP/潮玩品牌的正品信任交易引擎
            </p>
            <div className="flex items-center gap-4">
              <a href="https://weibo.com" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-cyber-neon transition-colors" title="官方微博">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-cyber-neon transition-colors">
                <MessageCircle className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-cyber-neon transition-colors">
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-bold text-white mb-4">产品</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-sm text-gray-400 hover:text-cyber-neon transition-colors">品牌店铺</a></li>
              <li><a href="/verify" className="text-sm text-gray-400 hover:text-cyber-neon transition-colors">防伪验真</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">支持</h4>
            <ul className="space-y-2">
              <li><a href="/verify" className="text-sm text-gray-400 hover:text-cyber-neon transition-colors">验真指引</a></li>
              <li><a href="mailto:support@phygital.cn" className="text-sm text-gray-400 hover:text-cyber-neon transition-colors">联系客服</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">法律</h4>
            <ul className="space-y-2">
              <li><a href="/admin/user-agreement" target="_blank" className="text-sm text-gray-400 hover:text-cyber-neon transition-colors">用户协议</a></li>
              <li><a href="/admin/privacy-policy" target="_blank" className="text-sm text-gray-400 hover:text-cyber-neon transition-colors">隐私政策</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-cyber-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Phygital. All rights reserved.
          </p>
          <p className="text-sm text-gray-500 flex items-center gap-1">
            Made with <Heart className="w-4 h-4 text-cyber-red fill-current" /> by Echo7m
          </p>
        </div>
      </div>
    </footer>
  )
}
